import * as React from 'react';
import { useStore } from 'react-context-hook';
import { Thanks } from '@app/modules/unsubscribe/component/thanks.component';
import { Unsubscribe } from './component';
export var UnsubscribePage = function () {
    var unsubscribe = useStore('unsubscribe', false)[0];
    var _a = React.useState(''), image = _a[0], setImage = _a[1];
    return React.createElement("div", null, unsubscribe ? React.createElement(Thanks, { logo: image }) : React.createElement(Unsubscribe, { logo: image }));
};
